import { TPersonalNavItem } from '@/shared/types/deprecated-types'

export const bonuses = {
	activeScore: 1300,
	waitingScore: 100,
	waitingDate: `23.09.2021`
}

export const sortPeriod = [
	{
		label: `Неделя`,
		value: `Неделя`
	},
	{
		label: `Месяц`,
		value: `Месяц`
	},
	{
		label: `Год`,
		value: `Год`
	}
]

export const sortDelivery = [
	{
		label: `Самовывоз`,
		value: `Самовывоз`
	},
	{
		label: `Курьер`,
		value: `Курьер`
	}
]

export const sortStatus = [
	{
		label: `Все`,
		value: `Все`
	},
	{
		label: `В доставке`,
		value: `В доставке`
	},
	{
		label: `Отменен`,
		value: `Отменен`
	}
]

export const navItems: TPersonalNavItem[] = [
	{
		name: `Мои бонусы`,
		link: `/personal/bonuses/`
	},
	// {
	// 	name: `Мой лимит`,
	// 	link: `/personal/limit/`
	// },
	{
		name: `Мои заказы`,
		link: `/personal/orders/`
	},
	{
		name: `Мои отзывы`,
		link: `/personal/reviews/`
	},
	{
		name: `Мой профиль`,
		link: `/personal/profile/`
	},
	{
		name: `Мои компании`,
		link: '/personal/companies/'
	},

	{
		name: `Настройки`,
		link: `/personal/tools/`
	}
]
